import { FunctionComponent } from 'react';

import './card-generator-detail.scss';

export interface CardGeneratorDetailProps {
	/**
	 * (Optional) Archived state
	 */
	archived?: boolean;
	/**
	 * (Optional) Shadow
	 */
	shadow?: boolean;
	/**
	 * (Optional) On nuclide overview
	 */
	nuclideOverview?: boolean;
	/**
	 * (Optional) Disabled
	 */
	isDisabled?: boolean;
}

/**
 * The card generator detail component
 */

export const CardGeneratorDetail: FunctionComponent<CardGeneratorDetailProps> = (props): JSX.Element => {
	const { children, shadow, nuclideOverview, isDisabled } = props;

	return (
		<div className={`card-generator-detail ${shadow ? 'card-generator-detail--shadow' : ''} ${nuclideOverview ? 'card-generator-detail--nuclide' : ''} ${isDisabled ? 'card-generator-detail--disabled' : ''}`}>
			<div className='card-generator-detail__content'>
				{children}
			</div>
		</div>
	);
};
